import { gql } from '@apollo/client';

/**
 * GraphQL query for fetching community details specifically for audit pages
 *
 * This query excludes moderationStats to avoid dependency on the Moderation Service,
 * which can cause failures when loading audit pages if moderation stats are unavailable.
 * Audit functionality doesn't require moderation statistics.
 */
export const GET_COMMUNITY_FOR_AUDIT = gql`
  query GetCommunityForAudit($id: ID!) {
    community(id: $id) {
      id
      name
      communityGroupId
      communityGroup {
        id
        name
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      logoUrl
      superHeroArtUrl
      optionalMetadata {
        description
        pgRating
        contentGenres
        contentStandardsUrl
        bigId
        contentRating {
          ratingSystem
          ratingValue
          ratingId
          description
          descriptors
          interactiveElements
          ratingUrl
        }
      }
      topics {
        name
        humanModerationAssignedTtlInSeconds
        maxCasesPerModerator
        humanModerationCasesSlaInSeconds
      }
      securityGroups {
        admin
        moderator
        user
      }
      userRole
      roles
    }
  }
`;
